import { BulkActionStatus } from '../../bulk.actions/enums';
import { BulkActionOutcomeSummary } from '../../bulk.actions/board.bulk.action.request';
import { ActivityEntityName } from '../../shared/activity.entity.name';
import { SocketRoomEvent } from '../tenant.notification.payload';
import { RoomKey } from '../socket.room.key';

export const UserRoomEventType = {
    AuthSessionRevoked: 'auth-session-revoked',
    BulkActionStarted: 'bulk-action:started',
    BulkActionProgressed: 'bulk-action:progressed',
    BulkActionCompleted: 'bulk-action:completed',
} as const;

export interface BulkActionUserRoomPayload {
    headerId: string;
    entity: ActivityEntityName;
    status: BulkActionStatus;
    total: number;
    success: number;
    skipped: number;
    failed: number;
    /** Terminal notifications carry grouped reasons, not every selected record or its data. */
    outcomes?: BulkActionOutcomeSummary[];
    /** Terminal Visit reschedules: tasks moved, from how many Visits, into how many distinct Visits. */
    movement?: { tasksMoved: number; fromVisits: number; resultingVisits: number };
    /** Terminal Approve / Withdraw / Reschedule kept approved: task stamps written across rows. */
    approval?: { tasksChanged: number; tasksSkipped: number; tasksAutoApproved?: number };
}

export type UserRoomMessage =
    | SocketRoomEvent<typeof UserRoomEventType.AuthSessionRevoked, { sessionId?: string; reason?: string }>
    | SocketRoomEvent<typeof UserRoomEventType.BulkActionStarted, BulkActionUserRoomPayload>
    | SocketRoomEvent<typeof UserRoomEventType.BulkActionProgressed, BulkActionUserRoomPayload>
    | SocketRoomEvent<typeof UserRoomEventType.BulkActionCompleted, BulkActionUserRoomPayload>;

export const UserRooms = {
    user: (userId: string): RoomKey<UserRoomMessage> => ({ key: userId }),
};
